module.exports = __webpack_public_path__ + "img/soup.f6ec8c1d.svg";